import { useState } from 'react';
import { useRoute, useLocation } from 'wouter';
import { Plus, Building2, ArrowLeft } from 'lucide-react';
import { AppShell } from '@/components/app-shell';
import { VendorList } from '@/components/vendor-list';
import { VendorDetail } from '@/components/vendor-detail';
import { NewVendorModal } from '@/components/new-vendor-modal';

export function VendorsPage() {
  const [match, params] = useRoute('/vendors/:publicId');
  const selectedVendorId = match ? params.publicId : null;
  const [newOpen, setNewOpen] = useState(false);
  const [, setLocation] = useLocation();

  return (
    <AppShell
      title="Vendors"
      subtitle="Roster of suppliers — auto-grows as quotes come in"
      headerActions={
        <>
          {selectedVendorId && (
            <button
              onClick={() => setLocation('/vendors')}
              className="lg:hidden btn-ghost px-2"
              aria-label="Back to vendor list"
            >
              <ArrowLeft className="w-4 h-4" />
              Back
            </button>
          )}
          <button onClick={() => setNewOpen(true)} className="btn-primary">
            <Plus className="w-4 h-4" />
            <span className="hidden sm:inline">New vendor</span>
            <span className="sm:hidden">New</span>
          </button>
        </>
      }
    >
      <div className="h-full lg:grid lg:grid-cols-[minmax(360px,40%)_1fr] overflow-hidden">
        <aside
          className={`h-full border-r border-border overflow-hidden bg-surface ${
            selectedVendorId ? 'hidden lg:block' : 'block'
          }`}
        >
          <VendorList selectedVendorId={selectedVendorId} />
        </aside>
        <section
          className={`h-full overflow-hidden bg-surface ${
            selectedVendorId ? 'block' : 'hidden lg:block'
          }`}
        >
          {selectedVendorId ? (
            <VendorDetail key={selectedVendorId} publicId={selectedVendorId} />
          ) : (
            <div className="h-full flex items-center justify-center px-8">
              <div className="text-center max-w-md">
                <div className="w-12 h-12 mx-auto rounded-full bg-primary-muted text-primary-strong flex items-center justify-center mb-3">
                  <Building2 className="w-6 h-6" />
                </div>
                <p className="text-sm text-foreground-muted">
                  Select a vendor on the left, or click <span className="font-medium text-foreground">New vendor</span> to add one.
                  Vendors auto-populate as quotes come in.
                </p>
              </div>
            </div>
          )}
        </section>
      </div>

      <NewVendorModal open={newOpen} onClose={() => setNewOpen(false)} />
    </AppShell>
  );
}
